<div class="flex-1 flex items-center justify-center">
    <div
        class="max-w-lg w-full rounded-3xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 p-10 shadow-2xl relative overflow-hidden">
        <div class="absolute top-0 left-0 right-0 h-40 bg-blue-600"></div>
        <div class="relative pt-16 flex flex-col items-center">
            <div
                class="w-40 h-40 rounded-full border-8 border-white dark:border-slate-900 bg-slate-200 overflow-hidden shadow-xl mb-8">
                <div class="w-full h-full flex items-center justify-center bg-blue-100 text-blue-600">
                    <i class="fa-solid fa-user text-6xl"></i>
                </div>
            </div>
            <h2 class="text-3xl font-black text-slate-900 dark:text-white uppercase">{{ currentUser.name }}</h2>
            <p class="text-lg font-bold text-blue-600 uppercase tracking-widest mb-10">{{
                currentUser.role }}</p>

            <div class="w-full grid grid-cols-1 gap-6 mb-10">
                <div
                    class="flex items-center justify-between p-6 rounded-2xl bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800">
                    <span class="text-sm font-black text-slate-400 uppercase tracking-widest">Email Address</span>
                    <span class="text-lg font-bold text-slate-700 dark:text-slate-300">{{ currentUser.email || 'N/A' }}</span>
                </div>
                <div
                    class="flex items-center justify-between p-6 rounded-2xl bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800">
                    <span class="text-sm font-black text-slate-400 uppercase tracking-widest">Access Role</span>
                    <span class="text-lg font-bold text-slate-700 dark:text-slate-300">{{ currentUser.role || 'N/A' }}</span>
                </div>
            </div>

            <button
                (click)="logout()"
                class="w-full py-5 rounded-2xl bg-rose-50 dark:bg-rose-900/20 text-rose-600 dark:text-rose-400 border border-rose-200 dark:border-rose-900/50 font-black uppercase tracking-widest text-sm hover:bg-rose-100 dark:hover:bg-rose-900/40 transition-all flex justify-center items-center gap-3">
                <i class="fa-solid fa-power-off"></i> Secure Logout
            </button>
        </div>
    </div>
</div>